<template>
	<div id="domains" class="container panel">
		<div class="row">
			<div class="col-md-3 sidebar">
				<side-bar></side-bar>
			</div>

			<div class="col-md-9 content">
				<dash-head title="Domains" subtitle="Password Security Portal"></dash-head>
				
				<div v-if="!showAddDomain">
					<list-group class="mt-4 mb-3" heading="Breached Credentials" :showSearch="true" @search-changed="searchChanged">
						<list-group-item 
							v-for="domain in results" 
							:key="domain.value" 
							:description="domain.value"
							:badge="(domain.notificationCount > 20) ? '20+': domain.notificationCount"
							:detail="domain.statusDetail" 
							:url="'/domain/' + domain.value">
						</list-group-item>
					</list-group>
					<div class="row">
						<div class="col-md-6">
							<table-pagination :page="1" :pages="3" :total="totalRows" :pageSize="pageSize" @page-changed="pageChanged"></table-pagination>
						</div>
						<div class="col-md-6">
							<div class="text-right">
								<button v-if="!isInRole('ReadOnly')" class="btn btn-outline-primary px-3" @click.prevent="showHideAddDomain(true)">Add Domain</button>
								<button v-if="!isInRole('ReadOnly')" class="btn btn-outline-primary px-3" @click.prevent="refreshDomains">Refresh View</button>
								<button v-if="!isInRole('ReadOnly')" class="btn btn-outline-primary px-3" @click.prevent="clearAllNotifications">Clear Notifications</button>
							</div>
						</div>
					</div>
				</div>

				<div v-if="showAddDomain">
					<hr class="mt-3 mb-3">
					<add-domain-form @close-add-domain="showHideAddDomain(false)"></add-domain-form>
				</div>

			</div>
		</div>
	</div>
	
</template>

<script>
	import SideBar from './SideBar'
	import DashHead from './DashHead'
	import ListGroup from './ListGroup'
	import ListGroupItem from './ListGroupItem'
	import AddDomainForm from './AddDomainForm'
	import TablePagination from './TablePagination'
	import api from '../api'

	import store from '../state'
import state from '../state'

	export default {
		name: 'DomainPanel',
		components: {SideBar, DashHead, ListGroup, ListGroupItem, AddDomainForm, TablePagination},
		data() {
			return {
				pageSize:12,
				currentPage:1,
				showAddDomain: false,
				search: ''
			}
		},
		methods: {
			showHideAddDomain(value) {
				this.showAddDomain = value;
			},
			pageChanged(value) {
				this.currentPage = value;
			},
			refreshDomains() {
				store.dispatch('refreshDomainsAsync');
			},
			isInRole(role) {
				if (!store.state.user || !store.state.user.roles) return;
				return store.state.user.roles.indexOf(role) > -1;
			},
			searchChanged(value) {
				this.search = value.toLowerCase();
			},
			async clearAllNotifications() {
				try
				{
					await api.delete(`/notifications/${this.name}/count/all`);	
					this.data = [];				
					this.pageChanged(1);

					//Also clear notifications from state
					for (var domain of store.getters.getDomains) {
						store.commit('setDomainNotificationCount', {domain, count: 0});
					}
				}
				catch(err) {				
					this.error = err + ""; //Get the string representation of the error		
					console.log(err);
				}
			},
		},
		computed: {
			domains() {
				return store.state.domains;
			},
			filteredDomains() {
				if (!this.search) return this.domains;
				return this.domains.filter(domain => domain.value.includes(this.search));
			},
			totalRows() {
				return this.filteredDomains.length;
			},
			results() {
				const start = (this.currentPage-1) * this.pageSize;		
				const data = this.filteredDomains;
				const results = [];								

				for (var domain of data.slice(start, start + this.pageSize)) {
					results.push(domain);
				}

				return results;
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/DomainPanel.vue